import React from 'react';
import PropTypes from 'prop-types';
import { sortAlphabetically } from '../../../../../data/lib/sort';
import DraggablePlaceholder from './DraggablePlaceholder';

export default class ComponentListEntry extends React.Component {
  static propTypes = {
    pageType: PropTypes.string.isRequired,
    componentStartDragging: PropTypes.func.isRequired,
    componentStopDragging: PropTypes.func.isRequired,
    renderArrow: PropTypes.func,
    availableComponents: PropTypes.func,
    darkClassName: PropTypes.string,
    dimClassName: PropTypes.string,
  }

  state = {
    activeIndex: undefined,
  };

  getComponentList = (components) => {
    const {
      componentStartDragging,
      componentStopDragging,
    } = this.props;

    return (
      components.map((component, index) => {
        const {
          type, defaultPayload, name, icon, region, componentId,
        } = component;

        return (
          <li key={index}>
            {React.createElement(
              DraggablePlaceholder,
              {
                componentStartDragging,
                componentStopDragging,
                type: region || type,
                name,
                icon,
                data: {
                  type,
                  payload: defaultPayload,
                  componentId,
                },
              },
            )}
          </li>
        );
      })
    );
  }

  handleClick = (index) => {
    this.setState({
      activeIndex: this.state.activeIndex === index ? null : index,
    });
  }

  render() {
    const { activeIndex } = this.state;
    const {
      renderArrow, availableComponents, darkClassName, dimClassName,
    } = this.props;
    const groupedComponents = availableComponents().reduce((componentGroups, component) => {
      const key = component.category;
      if (!componentGroups[key]) {
        componentGroups[key] = [];
      }
      componentGroups[key].push(component);
      return componentGroups;
    }, {});

    const allCategories = Object.keys(groupedComponents).sort().reverse();

    const componentList = allCategories.map((category, index) => {
      const components = groupedComponents[category]
        .sort((a, b) => sortAlphabetically(a.name, b.name));

      return (
        <div key={index}>
          <li
            key={index}
            onClick={() => this.handleClick(index)}
            style={{ cursor: 'pointer' }}
            className={activeIndex === index ? darkClassName : ''}
          >
            {category}
            {renderArrow(activeIndex === index)}
          </li>
          {activeIndex === index ?
            <div className={dimClassName}>{this.getComponentList(components)}</div> : ''}
        </div>
      );
    });
    return (
      <div>{componentList}</div>
    );
  }
}
